import { MicOff, X } from "lucide-react";
import "./MutePopupOverlay.scss";

interface MutePopupOverlayProps {
  onClose: () => void;
  showPopup: boolean;
}

function MutePopupOverlay({ onClose, showPopup }: MutePopupOverlayProps) {
  if (!showPopup) {
    return null;
  }

  return (
    <div className="mute-popup-overlay">
      <div className="popup-card">
        <div className="card-content">
          <div className="icon-wrapper primary">
            <MicOff size={18} />
          </div>
          <div className="message-text">
            <p className="title">Microphone is muted</p>
            <p className="subtitle">Unmute to record your voice</p>
          </div>
          <button
            className="close-button"
            onClick={onClose}
            title="Dismiss"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}

export default MutePopupOverlay;
export type { MutePopupOverlayProps };
